const api = {
  generateSsoParameters: (controlNumber) => `/integrations/CollateralAnalytics/GenerateSsoParameters/${controlNumber}`,
  generateSsoParametersRiskProfiler: (controlNumber) => `/integrations/CollateralAnalytics/GenerateSsoParametersRiskProfiler/${controlNumber}`,
  riskProfilerResults: (controlNumber) => `/integrations/CollateralAnalytics/RiskProfiler/${controlNumber}`,
};

export { api };
